/**
 * 字符串的空格截取
 * @param {String} str 字符串
 * @param {String} pos 位置
 */
export default function trim(str, pos = 'both') {
  if (pos === 'both') {
    return str.replace(/^\s+|\s+$/g, '')
  } else if (pos === 'left') {
    return str.replace(/^\s*/, '')
  } else if (pos === 'right') {
    return str.replace(/(\s*$)/g, '')
  } else if (pos === 'all') {
    return str.replace(/\s+/g, '')
  } else {
    return str
  }
}



// WEBPACK FOOTER //
// ./packages/utils/trim.js